/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { cn } from '@/shared/ui/utils/tailwind';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

/**
 * Styled textarea primitive applying DS tokens for border, radius, and background.
 * Use this instead of raw `<textarea>` elements throughout the application.
 */
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'w-full rounded-(--radius-md) border border-(--border-subtle)',
        'bg-(--surface-secondary) px-3.5 py-2.5 text-sm text-(--text-primary)',
        'outline-none resize-y placeholder:text-(--text-tertiary)',
        'focus:border-(--input-focus-ring) transition-colors duration-(--duration-fast)',
        className,
      )}
      {...props}
    />
  ),
);

Textarea.displayName = 'Textarea';
